<template>
<div class="card card-custom card-strech">
    <div class="card-header">
        <h3 class="card-title">Registro de Cinturones Negros</h3>
        <div class="card-toolbar">
            <div class="btn btn-danger font-weight-bolder" @click="open_dialog_selection = true">
                    <span class="svg-icon svg-icon-md">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <rect x="0" y="0" width="24" height="24"></rect>
                                <circle fill="#000000" cx="9" cy="15" r="6"></circle>
                                <path d="M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z" fill="#000000" opacity="0.3"></path>
                            </g>
                        </svg>
                    </span>Nuevo registro</div>
            <div class="justify-content-center">

                

                <!--<div class="d-flex align-items-center position-relative mr-2">

                    <div class="input-icon">
                        <input type="text" class="form-control" placeholder="Buscar..." id="kt_datatable_search_query">
                        <span>
                            <i class="fas fa-search text-muted"></i>
                        </span>
                    </div>

                </div>-->

            </div>
        </div>
    </div>
    <div class="card-body">
        <el-table :data="blackList" highlight-current-row height="500" :border="false">
                <el-table-column prop="personName" label="Participante"></el-table-column>
                <el-table-column prop="poomdan" label="Opciones" width="100">
                    <template #default="scope">
                        <el-button @click="openDialogRegister(scope.row)" size="small">Explorar</el-button>
                    </template>
                </el-table-column>
        </el-table>

    </div>

    <!--Selection person-->
    <DialogSelectionPerson 
        :visible.sync="open_dialog_selection" 
        :title="'Seleccione el participante'" :record_type="'DE'" 
        @openDialogRegister="openDialogRegister">
    </DialogSelectionPerson>

    <!--Save black Belts-->
    <DialogRegister
        :visible.sync="open_dialog_register"
        :title="title_dialog"
        :person="person"
        @loadBlackBelts="loadBlackBelts">
    </DialogRegister>

</div>
</template>

<script>
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module.js";

//services
import payrollService from "@/core/services/payroll.service"


//components
import DialogSelectionPerson from "@/views/pages/acreditation/DialogSelectionPerson"
import DialogRegister from "./DialogRegister"

export default {
    name: "BlackBeltsList",
    components: {
        DialogSelectionPerson,
        DialogRegister
    },
    data: () => ({
        open_dialog_selection: false,
        open_dialog_register: false,
        person: {},
        title_dialog: '',
        blackList: []
    }),
    methods: {
        openDialogRegister(data) {
            this.open_dialog_selection = false
            if(data){
                this.person = data
                this.title_dialog = 'Nuevo registro'
                this.open_dialog_register = true
            }
        },
        async loadBlackBelts(){
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await payrollService.getPoomDanes().then( (res) => {
                this.blackList = res.data
            }).catch( (error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                //code.Manager(error.response)
            }).finally( () => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        }
    },
    created(){
        this.loadBlackBelts()
    }
}
</script>
